import BkLogo from '../../assets/logo_bk.svg';
interface LogoComponentProps {
  height?: string;
}
const LogoComponent = ({ height = '2.5rem' }: LogoComponentProps) => {
  return (
    <div
      style={{
          display: 'flex',
                gap: '0.3125rem',
                alignItems: 'center',
                marginBottom: '0.625rem',
                marginLeft: '1.875rem',
                marginTop: '1.875rem',
      }}
    >
      <img src={BkLogo} style={{ height }} />
    </div>
  );
};

export default LogoComponent;